'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/max.js
// module id = /TgO
// module chunks = 3